const isAnyQueryLoading = (...queries) =>
  queries.some((query) => query.isLoading || !query.isSuccess)

export default isAnyQueryLoading
